import { createContext, useContext } from 'react';
import type { Screen } from './schema';

interface GeneratorContextValue {
  screens: Screen[];
  currentScreenId: string;
  setCurrentScreenId: (screenId: string) => void;
}

export const GeneratorContext = createContext<GeneratorContextValue | null>(
  null,
);

export function useGeneratorContext(): GeneratorContextValue {
  const ctx = useContext(GeneratorContext);
  if (!ctx) {
    throw new Error(
      'useGeneratorContext must be used within a <GeneratorContext.Provider> (rendered by <ScreensRenderer>)',
    );
  }
  return ctx;
}
